import React, { useState } from "react";
import { ValidationResult } from "sprint-common-web";

import { UpdateFileRecordVideoTechnicalRequest } from "../../../../../../../../common/api/master-api/file-records/update/technical/video/UpdateFileRecordVideoTechnicalRequest";
import { useFileRecordApi } from "../../../../../../../../common/api/master-api/file-records/useFileRecordApi";
import {
    ensureVideoFileRecordDetails,
    VideoFileRecordTechnical
} from "../../../../../../../common/file-record-details/FileRecordDetails";
import { useFileRecordDetailsState } from "../../../../../hooks/useFileRecordDetailsState";
import { VideoTechnicalForm } from "./EditVideoTechnicalForm";

export interface EditVideoTechnicalInfoAsideContentProps {
    fileRecordId: string;
    onCancel(): void;
    onSubmit(): void;
}

export const EditVideoTechnicalInfoAsideContent = (props: EditVideoTechnicalInfoAsideContentProps): JSX.Element => {
    const { fileRecordId, onSubmit, onCancel } = props;

    const { fileRecordDetails, setFileRecordDetails } = useFileRecordDetailsState();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [validationResult, setValidationResult] = useState<ValidationResult>();
    const { updateFileRecordVideoTechnical } = useFileRecordApi();

    const updateVideoTechnical = (technicalInfo: VideoFileRecordTechnical) => {
        ensureVideoFileRecordDetails(fileRecordDetails);

        const request: UpdateFileRecordVideoTechnicalRequest = {
            id: fileRecordId,
            technical: mapToTechnicalInfo(technicalInfo)
        };

        setIsLoading(true);

        updateFileRecordVideoTechnical(request)
            .then(() => {
                setFileRecordDetails({
                    ...fileRecordDetails,
                    technical: technicalInfo
                });

                onSubmit();
            })
            .catch((res) => {
                setValidationResult(res);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <VideoTechnicalForm
            isLoading={isLoading}
            onCancel={onCancel}
            onSubmit={updateVideoTechnical}
            validationResult={validationResult}
        />
    );
};

const mapToTechnicalInfo = (technicalInfo: VideoFileRecordTechnical) => {
    return {
        ...technicalInfo,
        videoBitRate: technicalInfo.videoBitRate || undefined
    };
};
